import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';

import Course from '@/content/models/course.model';
import { SECTIONS_CAN_BE_PDF, SECTION_TYPES } from '@/content/values/sections';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import PrintMixin from '@/courses/mixins/print-mixin';
import { COURSE_MATERIAL_KEYS } from '@/courses/values/courses.values';

@Component({
  name: 'ed-pdf-print'
})
export default class EdPdfPrintComponent extends Mixins(CourseToolsMixin, PrintMixin) {

  @Prop() readonly courseId: number;

  public isFileInCache = false;

  get course(): Course {
    return this.getCourseFromStore({ courseId: this.courseId })
  }

  get isSectionPrintOptionAvailable(): boolean {
    return this.course && this.course.viewer.sectionSelected && !this.$store.getters['AuthStore/isStudent'];
  }

  get isProjectPrintOptionAvailable(): boolean {
    return this.course && this.course.viewer.projectSelected?.section && !this.$store.getters['AuthStore/isStudent'];
  }

  get canPrint() {
    let canPrint = false;
    if (this.isSectionPrintOptionAvailable) {
      if (SECTIONS_CAN_BE_PDF.includes(this.course.viewer.sectionSelected.type)) {
        if(this.course.viewer.sectionSelected.type === SECTION_TYPES.LESSON_MATERIAL.code) {
          canPrint = this.course.viewer.sectionSelected.sectionMaterial.materialAssetInfo.pdfUrl ? true : false;
        } else if(this.course.viewer.sectionSelected.type !== SECTION_TYPES.LESSON_PDF.code) {
          canPrint = this.course.viewer.sectionSelected?.assetsInfo[0]?.pdfUrl ? true : false;
        } else {
          canPrint = (this.course.viewer.sectionSelected?.assetsInfo && this.course.viewer.sectionSelected?.assetsInfo[0]?.url) ? true : false;
        }
      }
    }
    
    if (this.isProjectPrintOptionAvailable) {
      if(SECTIONS_CAN_BE_PDF.includes(this.course.viewer.projectSelected?.section.type)) {
        if(this.course.viewer.projectSelected.section.type === SECTION_TYPES.LESSON_MATERIAL.code) {
          canPrint = this.course.viewer.projectSelected.section.sectionMaterial.materialAssetInfo.pdfUrl ? true : false;
        } else if(this.course.viewer.projectSelected.section.type !== SECTION_TYPES.LESSON_PDF.code) {
          canPrint = this.course.viewer.projectSelected.section?.assetsInfo[0]?.pdfUrl ? true : false;
        } else {
          canPrint = (this.course.viewer.projectSelected.section?.assetsInfo && this.course.viewer.projectSelected.section?.assetsInfo[0]?.url)  ? true : false;
        }
      }
    }
    return canPrint;
  }

  get pdfLoading(): boolean {
    return this.$store.state.CourseStore.pdfLoading;
  }

  get url() {
    let url = '';
    const sectionSelected = this.course.viewer.sectionSelected;
    if (this.course && this.canPrint && sectionSelected) {
      if (sectionSelected.type === SECTION_TYPES.LESSON_MATERIAL.code) {
        url = sectionSelected.sectionMaterial.displayType === COURSE_MATERIAL_KEYS.SPLICE
          ? sectionSelected.sectionMaterial.splicedUrl
          : sectionSelected.sectionMaterial.materialAssetInfo.pdfUrl;
      } else if (sectionSelected.type !== SECTION_TYPES.LESSON_PDF.code) {
        url = sectionSelected?.assetsInfo[0]?.pdfUrl;
      } else {
        url = sectionSelected?.assetsInfo[0]?.pdfUrl
          ?? sectionSelected?.assetsInfo[0]?.url;
      }
    }
    const projectSelected = this.course.viewer.projectSelected;
    if (this.course && this.canPrint && projectSelected?.section) {
      if (projectSelected.section.type === SECTION_TYPES.LESSON_MATERIAL.code) {
        url = projectSelected.section.sectionMaterial.materialAssetInfo.pdfUrl;
      } else if (projectSelected.section.type !== SECTION_TYPES.LESSON_PDF.code) {
        url = projectSelected.section?.assetsInfo[0]?.pdfUrl;
      } else {
        url = projectSelected.section?.assetsInfo[0]?.pdfUrl
          ?? projectSelected.section?.assetsInfo[0]?.url;
      }
    }
    return url;
  }

  get iconClass() {
    return {
      'ed-icon--disabled': this.pdfLoading
    }
  }

  get isPrintIconAvailable(): boolean {
    const isWebView = this.$store.state.AppStore.webview;
    return this.canPrint && !isWebView && !this.printing && this.isShowSreenTeacher;
  }

  get hash(): string {
    const url = this.url.substring(this.url.lastIndexOf('/') + 1);
    return url.split('#')[0];
  }

  async goToPrint() {
    if (!this.pdfLoading && !this.printing && this.url) {
      await this.handlePrinting(this.url);
    }
  }
}
